import { render, staticRenderFns } from "./DiagnosisNotes.vue?vue&type=template&id=1de5f578&"
import script from "./DiagnosisNotes.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de5f578')) {
      api.createRecord('1de5f578', component.options)
    } else {
      api.reload('1de5f578', component.options)
    }
    module.hot.accept("./DiagnosisNotes.vue?vue&type=template&id=1de5f578&", function () {
      api.rerender('1de5f578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/diagnosis/DiagnosisNotes.vue"
export default component.exports